import React from 'react';
import { Field, Form, Formik } from 'formik';
import { PageSection } from 'adc-ui-components';

import UpsMethodContent from '../../../components/orders/UpsMethodContent';
import GoBack from '../../../components/GoBack';
import GenericError from '../../Errors/GenericError';


const UpsOnly = ({
  selectedDevices,
  submitLoading,
  handleSubmit,
  method,
  handleChooseReturnMethod,
  submitError,
}) => {
  if (submitError) {
    return <GenericError />;
  }

  return (
    <PageSection className="ui-grey">
      <div className="hgroup">
        <h1 className="heading2">
          {`How to return your device${(selectedDevices.length > 1) ? 's' : ''} by UPS`}
        </h1>
        <p>It may take up to 45 days for this return to be reflected on your account.</p>
      </div>
      <Formik onSubmit={handleChooseReturnMethod} noValidate>
        <Form>
          <Field type="hidden" name="method" value="ups" />
          <UpsMethodContent hideTop />
          <div className="action action--right">
            <div className="action__item">
              <button type="submit" className={`button button--primary ${submitLoading && 'is-loading'}`} disabled={submitLoading}>Confirm</button>
            </div>
            <div className="action__item">
              <GoBack>Back</GoBack>
            </div>
          </div>
        </Form>
      </Formik>
    </PageSection>
  );
};

export default UpsOnly;
